<template>
    <div class="slider"
         v-touch:swipe.right="setPrevSlide"
         v-touch:swipe.left="setNextSlide"
         v-if="slides && slides.length > 0">
        <div v-if="options.arrows"
             class="arrow prev-arrow"
             @click="setPrevSlide">
            <i class="fa fa-2x fa-chevron-left"></i>
        </div>
        <div class="slides">
            <transition-group tag="div" :name="options.transitionType" mode="in-out">
                <div :key="slide.id" class="slide" v-for="(slide,index) in visibleSlides"
                     :class="getSlideClass()">
                    <div v-if="options.links">
                        <a :href="slide.link" :title="slide.alt">
                            <img :src="mobile ? slide.original : slide.original" :alt="slide.alt">
                        </a>
                    </div>
                    <div v-else>
                        <img :src="mobile ? slide.original : slide.original" :alt="slide.alt">
                    </div>
                    <div class="slider-text" v-if="options.titles">
                        {{ slide.title }}
                    </div>
                </div>
            </transition-group>
        </div>
        <div v-if="options.arrows"
             class="arrow next-arrow"
             @click="setNextSlide">
            <i class="fa fa-2x fa-chevron-right"></i>
        </div>
        <div v-if="options.thumbDots && visibleThumbDots.length > 1"
             class="thumb-dots">
            <img v-for="(thumbDot,index) in visibleThumbDots"
                 @click="changeImageByDot(thumbDot.id)"
                 :src="thumbDot.thumb"
                 :alt="thumbDot.alt"
                 :class="visibleSlides[0].id === thumbDot.id ? 'active' : ''">
        </div>
        <div v-if="options.dots && dots.length > 1"
             class="dots">
            <span v-for="(dot,index) in dots"
                  @click="changeImage(index)"
                  class="dot"
                  :class="currentSlidesIndex === index ? 'active' : ''">
            </span>
        </div>
    </div>
</template>

<script>
  import Vue2TouchEvents from 'vue2-touch-events';

  Vue.use(Vue2TouchEvents);

  // available transition type fade, scroll
  export default {
    name: 'SiteSlider',
    props: {
      customOptions: {
        required: false,
        type: Object
      },
    },
    data() {
      return {
        maxScrollSteps: 0,
        currentSlidesIndex: 0,
        timeToNextSlide: 0,
        mobile: false,
        slides,
        scrollTo: 'left-scroll',
        loading: true,
        options: {
          links: true,
          titles: true,
          arrows: false,
          transitionType: 'fade',
          autoScroll: true,
          speed: 4500,
          dots: false,
          thumbDots: false,
          showThumbDots: 3,
          slidesToShow: 1,
          slidesToScroll: 1
        },
      }
    },
    computed: {
      visibleSlides() {
        if (this.options.slidesToShow !== 1 && this.slides && this.slides.length >= this.options.slidesToShow) {
          let take = this.options.slidesToShow + this.skipSlides;
          let slides = this.slides.slice(this.skipSlides, take);

          //if needed length smaller then current
          if (this.slides && this.options.slidesToShow > slides.length) {
            let lacks = this.options.slidesToShow - slides.length;
            let lacks_slides = this.slides.slice(0, lacks);
            slides = slides.concat(lacks_slides);
          }

          return slides;
        }
        else {
          return [this.slides[this.skipSlides]];
        }
      },
      visibleThumbDots() {
        let visible = [];

        if (this.options.thumbDots && !this.loading) {
          let prev = this.getPrevSlide();
          let next = this.getNextSlide();

          visible = visible.concat(this.slides[prev], this.visibleSlides, this.slides[next]);
        }

        return visible;
      },
      dots() {
        let dots = [];

        if (this.options.dots) {
          for (let i = 0; i < this.maxScrollSteps; i++) {
            dots.push(i);
          }
        }

        return dots;
      },
      skipSlides() {
        let skip = this.currentSlidesIndex;
        if (this.options.slidesToScroll !== 1) {
          skip = this.currentSlidesIndex * this.options.slidesToScroll;
        }
        return skip;
      }
    },
    watch: {
      timeToNextSlide: function () {
        if (this.timeToNextSlide >= this.options.speed && this.options.autoScroll) {
          this.setNextSlide();
          this.resetTimeToNextSlide();
        }
      },
      currentSlidesIndex: function (newVal, oldVal) {
        if (newVal > oldVal) {
          this.scrollTo = 'left-scroll';
        }
        else {
          this.scrollTo = 'right-scroll';
        }
      }
    },
    methods: {
      setPrevSlide() {
        this.currentSlidesIndex = this.getPrevSlide();
      },
      setNextSlide() {
        this.currentSlidesIndex = this.getNextSlide();
      },
      getPrevSlide() {
        return helpers.getPreviousElement(this.maxScrollSteps, this.currentSlidesIndex);
      },
      getNextSlide() {
        return helpers.getNextElement(this.maxScrollSteps, this.currentSlidesIndex);
      },
      changeImage(key) {
        this.currentSlidesIndex = key;
      },
      changeImageByDot(id) {
        let imgIndex = this.slides.findIndex((element, index, array) => {
          if (element.id === id) {
            return element;
          }
        });

        this.currentSlidesIndex = imgIndex;
      },
      startAutoSlide() {
        setInterval(() => {
          this.timeToNextSlide += 500;
        }, 500);
      },
      resetTimeToNextSlide() {
        this.timeToNextSlide = 0;
      },
      getSlideClass() {
        let slideClass = this.scrollTo;

        if (this.visibleSlides.length > 1) {
          slideClass += ' inline-slides';
        }

        return slideClass;
      }
    },
    updated: function () {
      this.resetTimeToNextSlide();
    },
    mounted() {
      //check on mobile devices
      if (document.documentElement.clientWidth <= 768) {
        this.mobile = true;
      }

      //set custom options from props
      if (this.customOptions) {
        for (let index in this.customOptions) {
          if (this.options.hasOwnProperty(index)) {
            this.options[index] = this.customOptions[index];
          }
        }
      }

      this.maxScrollSteps = this.slides ? Math.ceil(this.slides.length / this.options.slidesToScroll) : 0;

      //enable auto scroll
      if (this.options.autoScroll) {
        this.startAutoSlide();
      }

      this.loading = false;
    }
  }
</script>
